import {useDispatch, useSelector} from "react-redux";
import {RegionSelectProps} from "../../Filters";
import React from "react";
import {selectedTypeIdSelectorMonitoring, setSelectedTypeIdMonitoring} from "../Selectors/filtersSliceMonitoring";

export const useSelectedTypeIdMonitoring = () => {
    const dispatch = useDispatch();
    const typeId = useSelector(selectedTypeIdSelectorMonitoring);

    const onSelectType: NonNullable<RegionSelectProps['onSelect']> = React.useCallback((id) => {
        dispatch(setSelectedTypeIdMonitoring({ id }));
    }, [dispatch]);
    return {
        typeId,
        onSelectType
    };
}